export interface Organization {
  id?: string;
  organizationName: string,
  provinceId: number,
  isActive: boolean
}

export function OrganizationDefaultValues(): Organization {
  return {
    id: undefined,
    organizationName: '',
    provinceId: 0,
    isActive: true
  }
}

export interface ViewOrg {
    id: string,
    organizationName: string,
    province: string,
    status: string,
    organizationMembers: any[]
}

export function ViewOrgDefaultValues(): ViewOrg {
  return{
    id: '',
    organizationName: '',
    province: '',
    status: '',
    organizationMembers: []
  }
}
